import React, { useState } from 'react';
import styles from './WithdrawalMethodModal.module.scss';

//assets
import SVG from 'react-inlinesvg';
import Close from '../../../assets/icons/close.svg';
import { Button } from '../../../components/Button/Button';
import bankIcon from '../../../assets/icons/icons-bank-account.svg';
import paypal from '../../../assets/icons/icons-paypal-small.svg';
//Tr
import { useTranslation } from 'react-i18next';
import { tr } from '../../../utils/translations/translator';
import { validateEmail } from './functions';

export interface OwnProps {
  loading: boolean;
  isOpen: boolean;
  setIsOpen: (boolean: boolean) => void;
  country: string;
  handleSEditPayoutMethod: (data: any) => any;
}

export const WithdrawalMethodsModal: React.FC<OwnProps> = ({
  isOpen,
  setIsOpen,
  handleSEditPayoutMethod,
  country,
}) => {
  const { t } = useTranslation();
  const [method, setMethod] = useState<string | undefined>(undefined);
  const [popupStep, setPopupStep] = useState(1);
  const [account, setAccount] = useState<string | undefined>(undefined);
  const [email, setEmail] = useState<string | undefined>(undefined);
  const [bank_name, setBank_name] = useState<string | undefined>(undefined);
  const [bank_address, setBank_address] = useState<string | undefined>(
    undefined,
  );
  const [clabe, setClabe] = useState<string | undefined>(undefined);
  const [swift_code, setSwift_code] = useState<string | undefined>(undefined);

  function isAccountValid(IBAN: string): boolean {
    const trimmedIBAN = IBAN.replaceAll(' ', '');
    const ibanRegex: RegExp = /^[A-Z]{2}\d{2}[A-Z0-9]{1,30}$/;
    if (!trimmedIBAN.replaceAll(' ', '').match(ibanRegex)) return false;

    const normalizedIBAN: string = trimmedIBAN.toUpperCase();
    const rearrangedIBAN: string =
      normalizedIBAN.substr(4) + normalizedIBAN.substr(0, 4);
    const digits: string = rearrangedIBAN
      .split('')
      .map((char: string) => {
        const code: number = char.charCodeAt(0);
        return code >= 65 && code <= 90 ? (code - 55).toString() : char;
      })
      .join('');

    let remainder: any = '';
    for (let i: number = 0; i < digits.length; i += 7) {
      const partialIBAN: string = remainder + digits.substring(i, i + 7);
      remainder = parseInt(partialIBAN, 10) % 97;
    }

    return remainder === 1;
  }
  const isBankDataValid = () => {
    if (country === 'ES') {
      return account && isAccountValid(account);
    } else {
      if (country === 'MX' && !clabe) {
        return false;
      } else if (
        !bank_name ||
        !bank_address ||
        !swift_code ||
        !account ||
        !isAccountValid(account)
      ) {
        return false;
      } else return true;
    }
  };

  const formatData = () => {
    if (method === 'PAYPAL') {
      return { type: 'PAYPAL', value: email };
    } else {
      if (country === 'ES') {
        return { type: 'BANK', value: account };
      } else if (country === 'MX') {
        return {
          type: 'BANK',
          value: account,
          bank_name,
          bank_address,
          swift_code,
          clabe,
        };
      } else {
        return {
          type: 'BANK',
          value: account,
          bank_name,
          bank_address,
          swift_code,
        };
      }
    }
  };
  const handleSubmit = () => {
    handleSEditPayoutMethod(formatData());
    setIsOpen(false);
    setPopupStep(1);
  };
  return (
    <div className={styles.container} id={styles.payouts}>
      {isOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalWrapper}>
            <a //eslint-disable-line
              onClick={() => {
                setIsOpen(false);
                setPopupStep(1);
              }}
            >
              <SVG src={Close} />
            </a>
            {popupStep === 1 ? (
              <div className={styles.modalTextWrapper}>
                <p>{tr(t, 'edit-payment-methods_title')}</p>
                <button
                  className={styles.paymentMethodBtn}
                  onClick={() => {
                    setMethod('BANK');
                    setPopupStep(2);
                  }}
                >
                  <SVG src={bankIcon}></SVG>
                  BANK
                </button>
                <button
                  className={styles.paymentMethodBtn}
                  onClick={() => {
                    setMethod('PAYPAL');
                    setPopupStep(2);
                  }}
                >
                  <SVG src={paypal}></SVG>
                  PAYPAL
                </button>
              </div>
            ) : (
              <>
                {method === 'BANK' &&
                  (country === 'ES' ? (
                    <div className={styles.modalTextWrapper}>
                      <p>{tr(t, 'edit-payment-methods_title_bank_ES')}</p>
                      <input
                        onChange={(e: any) => setAccount(e.target.value)}
                        placeholder="ES00 0000 0000 00 0000000000"
                      ></input>
                      <Button
                        theme="primary"
                        action={() => handleSubmit()}
                        text={tr(t, 'save')}
                        disabled={!isBankDataValid()}
                      ></Button>
                    </div>
                  ) : (
                    <div className={styles.modalTextWrapper}>
                      <p>{tr(t, 'edit-payment-methods_title_bank')}</p>
                      <div className={styles.bankDataTable}>
                        <div>
                          <input
                            className={styles.tableInput}
                            onChange={(e: any) => setBank_name(e.target.value)}
                            placeholder={tr(t, 'bank')}
                          ></input>
                          <input
                            className={styles.tableInput}
                            onChange={(e: any) =>
                              setBank_address(e.target.value)
                            }
                            placeholder={tr(t, 'bank_address')}
                          ></input>
                        </div>
                        <div>
                          {country === 'MX' && (
                            <input
                              className={styles.tableInput}
                              onChange={(e: any) => setClabe(e.target.value)}
                              placeholder="CLABE"
                            ></input>
                          )}

                          <input
                            className={styles.tableInput}
                            onChange={(e: any) => setSwift_code(e.target.value)}
                            placeholder="SWIFT"
                          ></input>
                        </div>

                        <div>
                          <input
                            className={styles.tableInput}
                            onChange={(e: any) => setAccount(e.target.value)}
                            placeholder={tr(t, 'account_number')}
                          ></input>
                        </div>
                      </div>
                      <Button
                        theme="primary"
                        action={() => handleSubmit()}
                        text={tr(t, 'save')}
                        disabled={!isBankDataValid()}
                      ></Button>
                    </div>
                  ))}
                {method === 'PAYPAL' && (
                  <div className={styles.modalTextWrapper}>
                    <p>{tr(t, 'edit-payment-methods_title_paypal')}</p>
                    <input
                      onChange={(e: any) => setEmail(e.target.value)}
                      placeholder={tr(t, 'email')}
                    ></input>
                    <Button
                      theme="primary"
                      action={() => handleSubmit()}
                      text={tr(t, 'save')}
                      disabled={!email || !validateEmail(email)}
                    ></Button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
